import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class DeleteButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {returnOrder} = this.props;
    this.props.deletePartsReturnOrder(returnOrder.code);
  }

  render() {
    const {returnOrder, deleting, processing} = this.props;

    if (!returnOrder || returnOrder.status !== 'I') {
      return null;
    }

    return (
      <Button primary
        content='ELIMINAR'
        disabled={processing || deleting}
        onClick={this.handleClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'processing': state.partsReturnsOrders.processing,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'deleting': state.partsReturnsOrders.deleting,
  };
};

const {
  deletePartsReturnOrder,
} = Actions;

export default connect(mapStateToProps, {
  deletePartsReturnOrder,
})(DeleteButton);
